export const BlockedIcon = ({ ...props }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.22929 3.22941L10.7706 10.7707M12.3333 7.00008C12.3333 9.9456 9.94548 12.3334 6.99996 12.3334C4.05444 12.3334 1.66663 9.9456 1.66663 7.00008C1.66663 4.05456 4.05444 1.66675 6.99996 1.66675C9.94548 1.66675 12.3333 4.05456 12.3333 7.00008Z"
        stroke="#FF3541"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
